import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UntypedFormGroup, UntypedFormBuilder, Validators, Form } from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { IJoinUs, Icommon } from "../Shared/IJoinUs";
import { JoinUsService } from "../Shared/join-us.service";
import * as regexPatterns from "../Shared/Data/regex-patterns";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NguCarouselConfig } from "@ngu/carousel";
import { interval, Observable, Subscription } from "rxjs";

import { SwiperComponent } from "swiper/angular";
import SwiperCore, {
  Pagination,
  Navigation,
  Lazy,
  Autoplay,
  Mousewheel,
  Swiper,
} from "swiper";

// install Swiper modules
SwiperCore.use([Lazy, Pagination, Navigation, Autoplay, Mousewheel]);
declare var $: any;
@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomePageComponent implements OnInit {
  intervalId: any;
  subscription: Subscription;
  toggleProperty = false;
  busContactForm: UntypedFormGroup;
  xInterval: any;
  private busContactFormB: UntypedFormBuilder;

  loader: boolean = true;
  catagory: Icommon[] = [];
  transactionsNumber: number = 50800;
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);

  parameterValue;

  constructor(
    private route: Router,
    private _activatedRoute: ActivatedRoute,
    config: NgbCarouselConfig,
    private fb: UntypedFormBuilder,
    private joinserv: JoinUsService,
    private _formBuilder: UntypedFormBuilder,
    private msg: ToastrService
  ) {
    setTimeout(() => {
      this.loader = false;
    }, 5000);
    config.interval = 10000;
    config.wrap = true;
    config.keyboard = true;
    config.pauseOnHover = true;
  }
  myform: UntypedFormGroup;
  indvform: UntypedFormGroup;
  messag: any = "";

  get idCtrl() {
    return this.myform.get("id");
  }
  get firstNameCtrl() {
    return this.myform.get("firstName");
  }
  get lastNameCtrl() {
    return this.myform.get("lastName");
  }
  get emailCtrl() {
    return this.myform.get("email");
  }
  get phoneCtrl() {
    return this.myform.get("phone");
  }
  get businessNameCtrl() {
    return this.myform.get("businessName");
  }
  get categoryCtrl() {
    return this.myform.get("category");
  } //
  get messageCtrl() {
    return this.myform.get("message");
  } //return this.messag; }

  get merchantCtrl() {
    return this.indvform.get("merchant");
  }

  public carouselTileItems$: Observable<number[]>;
  tempData: any[];

  imgags = [
    "../../../assets/images/Informatio.svg",
    "../../../assets/images/Informatin.svg",
    "../../../assets/images/Informaton.svg",
    "../../../assets/images/Informaion.svg",
  ];

  images2 = [
    {
      path: "../../../assets/images/newpartners/th__2_-removebg-preview 2.svg",
    },
    { path: "../../../assets/images/newpartners/paymobLogo2.svg" },
    { path: "../../../assets/images/newpartners/NBE-logo 1.svg" },
    { path: "../../../assets/images/newpartners/logo (3) 2.svg" },
    { path: "../../../assets/images/newpartners/image 33.svg" },
    { path: "../../../assets/images/newpartners/Frame 244.svg" },
    { path: "../../../assets/images/newpartners/fawry-logo-en-last 2.svg" },
  ];

  public carouselTileConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 3, lg: 3, all: 0 },
    speed: 250,
    point: {
      visible: true,
    },
    touch: true,
    loop: true,
    interval: { timing: 1500 },
  };

  ngOnInit() {
    this.parameterValue = "business";
    this._activatedRoute.params.subscribe((parameter) => {
      this.parameterValue = parameter.type;
    });

    this.indvform = this.fb.group({
      id: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]], // Validators.pattern(regexPatterns.emailPattern)]],//
      phone: ["", [Validators.required]], //Validators.pattern(regexPatterns.mobPattern)]],//
      merchant: [""], // CAT NAME, ID
      // branch: ["", Validators.required], // CAT NAME, ID
      message: ["", Validators.required],
    });

    this.myform = this.fb.group({
      id: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]], // Validators.pattern(regexPatterns.emailPattern)]],//
      phone: ["", [Validators.required]], //Validators.pattern(regexPatterns.mobPattern)]],//
      businessName: ["", Validators.required],
      category: ["", Validators.required], // CAT NAME, ID
      message: ["", Validators.required],
    });

    this.logadJQ();
    this.scrollAnimation();

    this.tempData = [];
  }

  pause = true;
  timer: any;

  ngAfterViewInit() {
    if (this.parameterValue == "individual") {
      let swiper = new Swiper(".textComp", {
        direction: "vertical",
        breakpoints: {
          767: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
          0: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      let doc = document.getElementById("listx1");

      let x = 2;
      swiper.slideTo(0);

      this.timer = setInterval(() => {
        if (this.pause) {
          doc.classList.remove("testClass");
          if (x == 9) {
            swiper.slideTo(0);
            x = 1;
          }
        } else if (this.pause == false) {
          doc = document.getElementById("listx" + x);
          doc.classList.add("testClass");
          if (x == 5) {
            swiper.slideTo(4);
          }
          x++;
        }
        this.pause = !this.pause;
      }, 700);
    } else {
      setTimeout(() => {
        let doc = document.getElementById("making2");
        doc.classList.add("makeBigger");

        doc = document.getElementById("making3");
        doc.classList.add("makeBigger3");
      }, 1000);
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  toggle() {
    this.toggleProperty = !this.toggleProperty;
  }

  redirect() {
    window.open("http://pay.klickit.co/", "_blank");
  }

  logadJQ(): void {
    $(document).ready(function () {
      var one = false;
      var two = false;
      var three = false;
      $("#sol1").hover(
        function () {
          if (window.matchMedia("(max-width: 767px)").matches) {
            // The viewport is less than 768 pixels wide
          } else {
            // The viewport is at least 768 pixels wide
            var contentHeight = $("#tw1").children("div").outerHeight();
            $("#tw1").css("max-height", contentHeight + "px");
            $(".sol1c").css("background", "#c2c1c1dc");
          }
        },
        function () {
          // nothing here
          if (!one) {
            $("#tw1").css("max-height", "0");
            $(".sol1c").css("background", "#fff");
          }
        }
      );

      $("#sol1").click(function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
          // The viewport is less than 768 pixels wide
          var contentHeight = 3 * $("#tw1").children("div").outerHeight();
          //console.log('in here');
          $("#tw1").css("max-height", contentHeight + "px");
          $(".sol1c").css("background", "#c2c1c1dc");
          $("#sol2").css("display", "none");
          $("#sol3").css("display", "none");
          one = !one;
          two = false;
          three = false;
          $("#tw2").css("max-height", "0");
          $(".sol2c").css("background", "#fff");
          $("#tw3").css("max-height", "0");
          $(".sol3c").css("background", "#fff");
          if (!one) {
            $("#tw1").css("max-height", "0");
            $(".sol1c").css("background", "#fff");
            $("#sol2").css("display", "inline-block");
            $("#sol3").css("display", "inline-block");
          }
        } else {
          // The viewport is at least 768 pixels wide
          one = !one;
          two = false;
          three = false;
          $("#tw2").css("max-height", "0");
          $(".sol2c").css("background", "#fff");
          $("#tw3").css("max-height", "0");
          $(".sol3c").css("background", "#fff");
          if (!one) {
            $("#tw1").css("max-height", "0");
            $(".sol1c").css("background", "#fff");
          }
        }
      });
      /////////////////////////

      $("#sol2").hover(
        function () {
          if (window.matchMedia("(max-width: 767px)").matches) {
            // The viewport is less than 768 pixels wide
          } else {
            // The viewport is at least 768 pixels wide
            var contentHeight = $("#tw2").children("div").outerHeight();
            $("#tw2").css("max-height", contentHeight + "px");
            $(".sol2c").css("background", "#c2c1c1dc");
          }
        },
        function () {
          if (!two) {
            $("#tw2").css("max-height", "0");
            $(".sol2c").css("background", "#fff");
          }
        }
      );

      $("#sol2").click(function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
          // The viewport is less than 768 pixels wide
          var contentHeight = 3 * $("#tw2").children("div").outerHeight();
          //console.log('in here');
          $("#tw2").css("max-height", contentHeight + "px");
          $(".sol2c").css("background", "#c2c1c1dc");
          $("#sol1").css("display", "none");
          $("#sol3").css("display", "none");
          two = !two;
          one = false;
          three = false;
          $("#tw1").css("max-height", "0");
          $(".sol1c").css("background", "#fff");
          $("#tw3").css("max-height", "0");
          $(".sol3c").css("background", "#fff");
          if (!two) {
            $("#tw2").css("max-height", "0");
            $(".sol2c").css("background", "#fff");
            $("#sol1").css("display", "inline-block");
            $("#sol3").css("display", "inline-block");
          }
        } else {
          // The viewport is at least 768 pixels wide
          two = !two;
          one = false;
          three = false;
          $("#tw1").css("max-height", "0");
          $(".sol1c").css("background", "#fff");
          $("#tw3").css("max-height", "0");
          $(".sol3c").css("background", "#fff");
          if (!two) {
            $("#tw2").css("max-height", "0");
            $(".sol2c").css("background", "#fff");
          }
        }
      });
      ////////////////////////////////////

      $("#sol3").hover(
        function () {
          if (window.matchMedia("(max-width: 767px)").matches) {
            // The viewport is less than 768 pixels wide
          } else {
            // The viewport is at least 768 pixels wide
            var contentHeight = $("#tw3").children("div").outerHeight();
            $("#tw3").css("max-height", contentHeight + "px");
            $(".sol3c").css("background", "#c2c1c1dc");
          }
        },
        function () {
          if (!three) {
            $("#tw3").css("max-height", "0");
            $(".sol3c").css("background", "#fff");
          }
        }
      );

      $("#sol3").click(function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
          // The viewport is less than 768 pixels wide
          var contentHeight = 3 * $("#tw3").children("div").outerHeight();
          //console.log('in here');
          $("#tw3").css("max-height", contentHeight + "px");
          $(".sol3c").css("background", "#c2c1c1dc");
          $("#sol1").css("display", "none");
          $("#sol2").css("display", "none");
          three = !three;
          one = false;
          two = false;
          $("#tw1").css("max-height", "0");
          $(".sol1c").css("background", "#fff");
          $("#tw2").css("max-height", "0");
          $(".sol2c").css("background", "#fff");
          if (!three) {
            $("#tw3").css("max-height", "0");
            $(".sol3c").css("background", "#fff");
            $("#sol1").css("display", "inline-block");
            $("#sol2").css("display", "inline-block");
          }
        } else {
          // The viewport is at least 768 pixels wide
          three = !three;
          two = false;
          one = false;
          $("#tw1").css("max-height", "0");
          $(".sol1c").css("background", "#fff");
          $("#tw2").css("max-height", "0");
          $(".sol2c").css("background", "#fff");
          if (!three) {
            $("#tw3").css("max-height", "0");
            $(".sol3c").css("background", "#fff");
          }
        }
      });
    });
  }

  scrollAnimation(): void {
    "use strict";

    //===== Prealoder

    $(window).on("load", function (event) {
      $(".preloader").delay(200).fadeOut(200);
    });

    //===== Mobile Menu

    $(".navbar-toggler").on("click", function () {
      $(this).toggleClass("active");
    });

    $(".navbar-nav a").on("click", function () {
      $(".navbar-toggler").removeClass("active");
    });

    //===== close navbar-collapse when a  clicked

    $(".navbar-nav a").on("click", function () {
      $(".navbar-collapse").removeClass("show");
    });

    //===== Sticky

    $(window).on("scroll", function (event) {
      var scroll = $(window).scrollTop();
      if (scroll < 10) {
        $(".navigation").removeClass("sticky");
      } else {
        $(".navigation").addClass("sticky");
      }
    });

    //===== Section Menu Active

    var scrollLink = $(".page-scroll");
    // Active link switching
    $(window).scroll(function () {
      var scrollbarLocation = $(this).scrollTop();

      scrollLink.each(function () {
        var sectionOffset = $(this.hash).offset().top - 73;

        if (sectionOffset <= scrollbarLocation) {
          $(this).parent().addClass("active");
          $(this).parent().siblings().removeClass("active");
        }
      });
    });

    // Parallaxmouse js

    function parallaxMouse() {
      if ($("#parallax").length) {
        var scene = document.getElementById("parallax");
        var parallax = new parallax(scene);
      }
    }
    parallaxMouse();

    //===== Progress Bar

    if ($(".progress-line").length) {
      $(".progress-line").appear(
        function () {
          var el = $(this);
          var percent = el.data("width");
          $(el).css("width", percent + "%");
        },
        { accY: 0 }
      );
    }

    //===== Counter Up
    // $('.counter').counterUp({
    //     delay: 10,
    //     time: 1600,
    // });

    //===== Magnific Popup

    // $('.image-popup').magnificPopup({
    //   type: 'image',
    //   gallery:{
    //     enabled:true
    //   }
    // });

    //===== Back to top

    // Show or hide the sticky footer button
    $(window).on("scroll", function (event) {
      if ($(this).scrollTop() > 600) {
        $(".back-to-top").fadeIn(200);
      } else {
        $(".back-to-top").fadeOut(200);
      }
    });

    //Animate the scroll to yop
    $(".back-to-top").on("click", function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1500
      );
    });
  }

  // clearIntervalFunc(x){
  //   console.log(this.xInterval)
  //   clearInterval(this.xInterval)
  // }

  getNumberOfTransactionsFirst() {
    this.joinserv.getNumberTransactions().subscribe(
      (response) => {
        // console.log("transactionssss   ", response);
        if (response.errorMessage) {
          this.msg.warning(response.errorMessage);
          this.loader = false;
          return;
        }
        this.transactionsNumber = response.result - 100;

        //this.loder.stop();
      },
      (err: HttpErrorResponse) => {
        console.log("error");
        console.log(err);
        //this.loder.stop();
        // if (err.status === 400) {
        //   this.msg.error(err.error);
        //   console.log('Error');
        // } else if (err.status === 503) {
        //   this.msg.error(err.error);
        // } else {
        //   this.msg.info('Unable To Access Server, Please refresh the page and try again');
        // }
      }
    );
  }
  getNumberOfTransactions() {
    // var xIntervalz=setInterval(()=>{
    //   this.transactionsNumber++;

    //   if(this.transactionsNumber==numbz){
    //     console.log(this.transactionsNumber)
    //     this.xInterval=null;
    //     clearInterval(xIntervalz)

    //     // this.clearIntervalFunc(this.xInterval);
    //   }
    // },10)

    // x;

    this.joinserv.getNumberTransactions().subscribe(
      (response) => {
        // console.log("transactionssss   ", response);
        if (response.errorMessage) {
          this.msg.warning(response.errorMessage);
          this.loader = false;
          return;
        }
        const timer = setInterval(() => {
          if (this.transactionsNumber < response.result) {
            this.transactionsNumber++;
          }
          // console.log(++this.transactionsNumber);
          if (this.transactionsNumber >= response.result) clearInterval(timer);
        }, 65);
        // this.transactionsNumber = response.result;

        //this.loder.stop();
      },
      (err: HttpErrorResponse) => {
        console.log("error");
        console.log(err);
        //this.loder.stop();
        // if (err.status === 400) {
        //   this.msg.error(err.error);
        //   console.log('Error');
        // } else if (err.status === 503) {
        //   this.msg.error(err.error);
        // } else {
        //   this.msg.info('Unable To Access Server, Please refresh the page and try again');
        // }
      }
    );
  }

  getAllServiveCategories() {
    this.joinserv.getServiveCategories().subscribe(
      (response) => {
        if (response.errorMessage) {
          this.msg.warning(response.errorMessage);
          this.loader = false;
          this.catagory = [];
          return;
        }
        this.catagory = response.result;
        console.log(response.result);
        //this.loder.stop();
      },
      (err: HttpErrorResponse) => {
        console.log("error");
        console.log(err);
        //this.loder.stop();
        // if (err.status === 400) {
        //   this.msg.error(err.error);
        //   console.log('Error');
        // } else if (err.status === 503) {
        //   this.msg.error(err.error);
        // } else {
        //   this.msg.info('Unable To Access Server, Please refresh the page and try again');
        // }
      }
    );
  }

  onSelectCatagory(e: any) {
    this.myform.get("category").setValue(e.value);
  }

  onSelectBranch(e: any) {
    this.indvform.get("branch").setValue(e.value);
  }

  onSelectMerchant(e: any) {
    this.indvform.get("merchant").setValue(e.value);
  }

  onSubmitIndv() {
    if (!this.indvform.valid) {
      this.msg.warning(
        "The data entered into a form needs to be in the right format and certain fields" +
          "need to be filled in order to effectively use the submitted form."
      );
      console.log("notvalid");
      return;
    } else {
      console.log("valid");
    }
    if (this.indvform.valid) {
      let myObj = {} as IJoinUs;
      myObj.firstName = this.indvform.get("firstName").value;
      myObj.lastName = this.indvform.get("lastName").value;
      myObj.email = this.indvform.get("email").value;
      myObj.phone = this.indvform.get("phone").value;
      // myObj.businessName = this.businessNameCtrl.value;
      // myObj.categoryId = (this.categoryCtrl.value as Icommon).id;
      // myObj.categoryName = (this.categoryCtrl.value as Icommon).name;

      // myObj.merchantId = (this.indvform.get("merchant").value as Icommon).id;
      // myObj.merchantName = this.indvform.get("merchant").value;

      // myObj.branchId = (this.indvform.get("branch").value as Icommon).id;
      // myObj.branchName = (this.indvform.get("branch").value as Icommon).name;
      myObj.notes = this.indvform.get("merchant").value
        ? this.indvform.get("merchant").value +
          "- " +
          this.indvform.get("message").value
        : this.indvform.get("message").value;
      // myObj.notes = this.messag; //  سبب المشكله
      myObj.key = "FFN07C5F5514F4DDA3CA9F96DE48119EC7EA";

      if (
        !myObj.firstName ||
        !myObj.lastName ||
        !myObj.email ||
        !myObj.phone
        // !myObj.merchantId ||
        // !myObj.branchId
        // !myObj.businessName ||
        // !myObj.categoryId
      ) {
        this.msg.warning(
          "The data entered into a form needs to be in the right format and certain fields" +
            "need to be filled in order to effectively use the submitted form."
        );
        return;
      }

      this.loader = true;
      this.joinserv.AddJoinUs(myObj).subscribe(
        (response) => {
          if (response.errorOccured) {
            this.msg.warning(response.errorMessage);
            this.loader = false;
            return;
          }
          this.loader = false;
          this.msg.success(response.result);
          //this.msg.success("Your Message Has been Sent Successfully...");
          // this.dialogRef.close(myObj);
        },
        (err: HttpErrorResponse) => {
          this.loader = false;
          // this.loder.stop();
          if (err.status === 400) {
            this.msg.error(err.error);
            console.log("Error");
          } else if (err.status === 503) {
            this.msg.error(err.error);
          } else {
            this.msg.info(
              "Unable To Access Server, Please refresh the page and try again"
            );
          }
        }
      );
    } else {
      this.msg.info("Nothing changed!");
    }
  }

  onSubmit() {
  
    if (!this.myform.valid) {
      this.msg.warning(
        "The data entered into a form needs to be in the right format and certain fields" +
          "need to be filled in order to effectively use the submitted form."
      );
      console.log("notvalid");
      return;
    } else {
      console.log("valid");
    }
    if (this.myform.valid) {
      let myObj = {} as IJoinUs;
      myObj.firstName = this.firstNameCtrl.value;
      myObj.lastName = this.lastNameCtrl.value;
      myObj.email = this.emailCtrl.value;
      myObj.phone = this.phoneCtrl.value;
      myObj.businessName = this.businessNameCtrl.value;
      myObj.categoryId = (this.categoryCtrl.value as Icommon).id;
      myObj.categoryName = (this.categoryCtrl.value as Icommon).name;
      myObj.notes = this.messageCtrl.value;
      // myObj.notes = this.messag; //  سبب المشكله
      myObj.key = "FFN07C5F5514F4DDA3CA9F96DE48119EC7EA";

      if (
        !myObj.firstName ||
        !myObj.lastName ||
        !myObj.email ||
        !myObj.phone ||
        !myObj.businessName ||
        !myObj.categoryId
      ) {
        this.msg.warning(
          "The data entered into a form needs to be in the right format and certain fields" +
            "need to be filled in order to effectively use the submitted form."
        );
        return;
      }

      this.loader = true;
      //console.log('NOW CALL SERVER: ', myObj);
      this.joinserv.AddJoinUs(myObj).subscribe(
        (response) => {
          if (response.errorOccured) {
            this.msg.warning(response.errorMessage);
            this.loader = false;
            return;
          }
          this.loader = false;
          this.msg.success(response.result);
          //this.msg.success("Your Message Has been Sent Successfully...");
          // this.dialogRef.close(myObj);
        },
        (err: HttpErrorResponse) => {
          this.loader = false;
          // this.loder.stop();
          if (err.status === 400) {
            this.msg.error(err.error);
            console.log("Error");
          } else if (err.status === 503) {
            this.msg.error(err.error);
          } else {
            this.msg.info(
              "Unable To Access Server, Please refresh the page and try again"
            );
          }
        }
      );
    } else {
      this.msg.info("Nothing changed!");
    }
  }
}
function startWith(
  arg0: number
): import("rxjs").OperatorFunction<number, unknown> {
  throw new Error("Function not implemented.");
}

function take(arg0: number): import("rxjs").OperatorFunction<unknown, unknown> {
  throw new Error("Function not implemented.");
}
